export const PRIMARY = "#fcb335"
export const COLORS = {
  SECONDARY_TEXT: "#a3a3aa",
}
